import React from 'react';

const CoreValuesCard = ({ coreValueCard }) => {
    return (
        <article className='core_values-card'>
            <h1 className="core_values-card-title">{coreValueCard.title}</h1>
            <span className="core_values-card-line" />
            <p className="core_values-card-para">{coreValueCard.text}</p>
        </article>
    );
}

export default CoreValuesCard;
